import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Association", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "col-md-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Active ", -1)
const _hoisted_12 = { class: "form-check form-switch form-check-custom form-check-solid mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isActive ? 'col-md-3' : 'col-md-2'])
    }, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_el_select, {
        class: "form-select-solid",
        placeholder: "Select Tranche",
        modelValue: _ctx.batch.tranche_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
        filterable: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "Tranche-1",
            value: "1"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tranche-1")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Tranche-2",
            value: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tranche-2")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Tranche-3",
            value: "3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tranche-3")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Tranche-4",
            value: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Tranche-4")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isActive ? 'col-md-3' : 'col-md-4'])
    }, [
      _hoisted_4,
      _createTextVNode(),
      _hoisted_5,
      _createVNode(_component_el_select, {
        class: "form-select-solid",
        placeholder: "Select Association",
        modelValue: _ctx.batch.entity_info_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_info_id) = $event)),
        filterable: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: info.id,
              label: info.entity_short_name,
              value: info.id
            }, {
              default: _withCtx(() => [
                _createTextVNode("[" + _toDisplayString(info.entity_short_name) + "]-" + _toDisplayString(info.entity_name), 1)
              ]),
              _: 2
            }, 1032, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    (_ctx.batch.course)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            placeholder: "Select Course",
            modelValue: _ctx.batch.course,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.course) = $event)),
            filterable: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "BACCO-MS | Medical Scribing | 2 | 160 | 31519",
                value: "1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("BACCO-MS | Medical Scribing | 2 | 160 | 31519")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.isActive ? 'col-md-3' : 'col-md-4'])
    }, [
      _hoisted_8,
      _hoisted_9,
      _createVNode(_component_el_select, {
        class: "form-select-solid",
        placeholder: "Select Training Institutes",
        modelValue: _ctx.batch.institute_info_id,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.institute_info_id) = $event)),
        filterable: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "Augmedix Bangladesh",
            value: "1"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Augmedix Bangladesh")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Genex Infosys Limited",
            value: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Genex Infosys Limited")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Mars Solutions Limited",
            value: "3"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Mars Solutions Limited")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Noble It Solution Ltd",
            value: "4"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Noble It Solution Ltd")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Digicon Technologies Ltd.",
            value: "5"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Digicon Technologies Ltd.")
            ]),
            _: 1
          }),
          _createVNode(_component_el_option, {
            label: "Service Solutions Pvt. Ltd.",
            value: "6"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Service Solutions Pvt. Ltd.")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    (_ctx.isActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("label", _hoisted_12, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "active_status",
              modelValue: _ctx.batch.active_status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.batch.active_status) = $event)),
              value: "1"
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["col-md-2 mt-2", { 'text-end': _ctx.isActive }])
    }, [
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchData())),
        type: "button",
        class: "btn btn-success mt-6 p-3",
        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
      }, [
        _createTextVNode(" Search "),
        _hoisted_13
      ])
    ], 2)
  ]))
}